"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_search__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f5a15098-b325-4ce9-9eab-b68d33d6953b",
    "data-name": "Ebene 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "89e4e861-afb1-4c4d-9a88-5acab32f1176",
    x1: 117.26,
    y1: 117.17,
    x2: 171.99,
    y2: 171.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2d02c8fc-82bd-48c0-b66e-9373f002d33e",
    x1: 71.15,
    y1: 25.79,
    x2: 118.18,
    y2: 94.5,
    gradientTransform: "translate(-12.69 15.29) rotate(-10.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "search-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,163.41,131.39,120,120.08,131.3l43.43,43.43a4,4,0,0,0,5.66,0l5.66-5.66A4,4,0,0,0,174.82,163.41Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.51,
    y: 115.41,
    width: 16,
    height: 12,
    transform: "translate(-50.26 121.49) rotate(-45)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,167.07l-5.66,5.66a4,4,0,0,1-5.66,0L121.08,130.3l-1,1,43.43,43.43a4,4,0,0,0,5.66,0l5.66-5.66a4,4,0,0,0,1-3.83A4,4,0,0,1,174.82,167.07Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,163.41,131.41,120h0l-8.49-8.49-11.31,11.31,8.47,8.47h0l43.43,43.43a4,4,0,0,0,5.66,0l5.66-5.66A4,4,0,0,0,174.82,163.41Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#89e4e861-afb1-4c4d-9a88-5acab32f1176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,26a50,50,0,1,0,50,50A50.06,50.06,0,0,0,76,26Z",
    transform: "translate(0 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,16a60,60,0,1,0,60,60A60.07,60.07,0,0,0,76,16Zm0,110a50,50,0,1,1,50-50A50.06,50.06,0,0,1,76,126Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,16a60,60,0,1,0,60,60A60.07,60.07,0,0,0,76,16Zm0,110a50,50,0,1,1,50-50A50.06,50.06,0,0,1,76,126Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,24A50.06,50.06,0,0,0,26,74c0,.34,0,.67,0,1A50,50,0,0,1,126,75c0-.33,0-.66,0-1A50.06,50.06,0,0,0,76,24Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,134A60.06,60.06,0,0,1,16,75c0,.33,0,.66,0,1a60,60,0,0,0,120,0c0-.34,0-.67,0-1A60.06,60.06,0,0,1,76,134Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,39.18a44.7,44.7,0,0,0-51.82,1,2.1,2.1,0,0,0,1.55,3.77,57.85,57.85,0,0,1,64,43.82,2.1,2.1,0,0,0,4.07.08A44.7,44.7,0,0,0,101.21,39.18Z",
    transform: "translate(0 0)",
    fill: "url(#2d02c8fc-82bd-48c0-b66e-9373f002d33e)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.08,
    cy: 44.94,
    r: 2.1,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -7.5, 9.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_search__dark;
exports.default = _default;